import { createClient } from '@supabase/supabase-js'
import { env } from './env'

const VIEW_AS_KEY = 'mezsites.viewAs'

/** "View as" target for this tab only (super admin). Sent as a header; the database enforces it. */
export const viewAs = {
  get(): string | null {
    try {
      return sessionStorage.getItem(VIEW_AS_KEY)
    } catch {
      return null
    }
  },
  set(userId: string | null) {
    try {
      if (userId) sessionStorage.setItem(VIEW_AS_KEY, userId)
      else sessionStorage.removeItem(VIEW_AS_KEY)
    } catch {
      // Private mode: view-as simply won't persist across reloads.
    }
  },
}

const withViewAs: typeof fetch = (input, init) => {
  const target = viewAs.get()
  if (!target) return fetch(input, init)
  const headers = new Headers(init?.headers)
  headers.set('x-view-as', target)
  return fetch(input, { ...init, headers })
}

export const supabase = createClient(
  env.supabaseUrl ?? 'http://localhost:54321',
  env.supabaseKey ?? 'missing-key',
  {
    auth: {
      // Reps stay signed in on their own device.
      persistSession: true,
      autoRefreshToken: true,
      // Picks up the session from password-reset links.
      detectSessionInUrl: true,
      storageKey: 'mezsites.auth',
    },
    global: { fetch: withViewAs },
  },
)
